import React, { PureComponent } from "react";
import "./Navigation.scss";
import Classnames from "classnames";

import { SECTION_MAPPING, SECONDARY } from "../../constants";
import { section } from "../../global-interfaces";

interface Props {
  setSection: Function;
  selectedSection: section;
  isMobile: boolean;
  isOpen: boolean;
  setNavStatus: Function;
}
interface State {}

class Navigation extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};

    this.toggleNav = this.toggleNav.bind(this);
  }

  toggleNav() {
    this.props.setNavStatus(!this.props.isOpen);
  }

  render() {
    const { isOpen, setNavStatus } = this.props;
    const { selectedSection, isMobile } = this.props;

    return (
      <div
        className={Classnames("Navigation", { isOpen })}
        tabIndex={0}
        onClick={this.toggleNav}
        onBlur={() => {
          // don't want to simply toggle, in iOS gets triggered by link copy
          setNavStatus(false);
        }}
        onMouseOver={isOpen || isMobile ? () => {} : this.toggleNav}
        onMouseOut={isOpen && !isMobile ? this.toggleNav : () => {}}
      >
        {// map over color tabs
        SECTION_MAPPING.map(d => (
          <div
            className={Classnames("nav-tab " + d.color, {
              [SECONDARY]: selectedSection.title !== d.title,
            })}
            key={d.title}
            onClick={() => isOpen && this.props.setSection(d)}
          >
            <img
              src={
                process.env.PUBLIC_URL +
                (selectedSection.title === d.title ? d.pathActive : d.path)
              }
            />
            {isOpen ? <span> {d.title} </span> : null}
          </div>
        ))}
      </div>
    );
  }
}

export default Navigation;
